import $ from "jquery";

$(document).on("click", ".stppg", function (event) {
  event.stopPropagation();
});
$(".mdl").on("click", ".stppg", function (event) {
  event.stopPropagation();
});
